import { createSlice } from '@reduxjs/toolkit';
import { getLatestReport } from './thunk';

export interface PerformanceIndicators {
  id?: string;
  store?: string;
  data?: any;
}

export interface IPerformanceIndicatorsData {
  currentReport: PerformanceIndicators | null;
  currentReportLoading: boolean;
}

const initialState: IPerformanceIndicatorsData = {
  currentReport: null,
  currentReportLoading: true,
};

const slice = createSlice({
  name: 'performanceIndicators',
  initialState,
  reducers: {
    clearPerformanceIndicatorsReport: (state) => {
      state.currentReport = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLatestReport.fulfilled, (state, action) => {
        const report = action.payload;
        if (report) {
          state.currentReport = action.payload;
        }
        state.currentReportLoading = false;
      })
      .addCase(getLatestReport.pending, (state) => {
        state.currentReportLoading = true;
      })
      .addCase(getLatestReport.rejected, (state) => {
        state.currentReportLoading = false;
      });
  },
});

export const { clearPerformanceIndicatorsReport } = slice.actions;
export default slice.reducer;
